module.exports = __webpack_public_path__ + "static/urbanArrowGeometry-596549664feb272f32dcbbb4c33383a7.jpg";